/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import {
    UserLabelState,
    UserLabelMutations,
    UserLabelActions,
    UserLabelGetters,
    UserLabelFilter,
    SortMenuItem,
    FilterItem,
} from '@/types';

const getDefaultState = () => {
    return {
        search: null,
        sort: [],
        page: 1,
        filter: {
            isActive: null,
        },
    } as UserLabelState;
};

const state: UserLabelState = getDefaultState();

const mutations: MutationTree<UserLabelState> = {
    [UserLabelMutations.SET_SEARCH]: (state, search: string) => (state.search = search),
    [UserLabelMutations.SET_SORT]: (state, sort: SortMenuItem[]) => (state.sort = sort),
    [UserLabelMutations.SET_PAGE]: (state, page: number) => (state.page = page),
    [UserLabelMutations.SET_FILTER](state, filter: UserLabelFilter) {
        state.filter.isActive = filter.isActive;
    },
    [UserLabelMutations.CLEAR_FILTER](state, item?: FilterItem) {
        switch (item?.field) {
            case 'isActive':
                state.filter.isActive = getDefaultState().filter.isActive;
                break;
            default:
                state.filter.isActive = getDefaultState().filter.isActive;
        }
    },
};

const actions: ActionTree<UserLabelState, any> = {
    [UserLabelActions.SET_SEARCH]: ({ commit }, search: string) =>
        commit(UserLabelMutations.SET_SEARCH, search),
    [UserLabelActions.SET_SORT]: ({ commit }, sort: SortMenuItem[]) =>
        commit(UserLabelMutations.SET_SORT, sort),
    [UserLabelActions.SET_PAGE]: ({ commit }, page: number) =>
        commit(UserLabelMutations.SET_PAGE, page),
    [UserLabelActions.SET_FILTER]: ({ commit }, filter: UserLabelFilter) =>
        commit(UserLabelMutations.SET_FILTER, filter),
    [UserLabelActions.CLEAR_FILTER]: ({ commit }, item: FilterItem) =>
        commit(UserLabelMutations.CLEAR_FILTER, item),
};

const getters: GetterTree<UserLabelState, any> = {
    [UserLabelGetters.SEARCH]: (state): string | null => state.search,
    [UserLabelGetters.SORT]: (state): SortMenuItem[] => state.sort,
    [UserLabelGetters.PAGE]: (state): number => state.page,
    [UserLabelGetters.FILTER]: (state): UserLabelFilter => state.filter,
    [UserLabelGetters.DEFAULT_FILTER]: (): UserLabelFilter => getDefaultState().filter,
    [UserLabelGetters.ACTIVE_FILTERS](state): FilterItem[] {
        const filters: Array<FilterItem> = [];

        if (state.filter.isActive !== null) {
            filters.push({
                field: 'isActive',
                value: state.filter.isActive.value,
                label: state.filter.isActive.label,
            });
        }

        return filters;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};
